import type { StyleRule } from '@archipro-design/aria';
import { PICKER_ICON, PICKER_ICON_SIZE } from '@modules/paint-picker/config';

export const PaintPickerShellStyle: StyleRule = ({ theme }) => ({
    height: '100%',
    width: '100%',
    opacity: 0.5,
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: theme.siteVariables.zIndexes.foreground,
    right: 0,
    bottom: 0,
    cursor: `${PICKER_ICON} ${PICKER_ICON_SIZE / 2} ${
        PICKER_ICON_SIZE / 2
    }, auto`,
});

export const PaintPickerMobileShellStyle: StyleRule = ({ theme }) => ({
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: theme.siteVariables.zIndexes.foreground,
    right: 0,
    bottom: 0,
});

export const CanvasStyling: StyleRule = () => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
    visibility: 'hidden',
});
